/**
 * "תרומה אנונימית" checkbox visibility — one rule, shared by the builder
 * canvas, the settings panel and the public page so all three agree.
 *
 * The checkbox only means something when the campaign shows donor names, so
 * the default follows the "תורמים אחרונים" block: present → shown, absent →
 * hidden. The editor can override that per campaign from the form block's
 * settings, and an explicit choice always wins over the default.
 *
 * Campaigns authored before the toggle moved to the form block carry the flag
 * on the payment-button block instead — an explicit "off" there is still
 * honored so their public page doesn't change under them.
 */
type AnonBlock = { type?: string; props?: Record<string, any> | null };

export const resolveShowAnonymousOption = (
  formProps: Record<string, any> | null | undefined,
  blocks: AnonBlock[] | null | undefined,
): boolean => {
  if (typeof formProps?.showAnonymousOption === 'boolean') return formProps.showAnonymousOption;
  const all = blocks || [];
  const payProps = all.find(b => b?.type === 'payment-button')?.props;
  if (payProps?.showAnonymousOption === false) return false;
  return all.some(b => b?.type === 'recent-donors');
};
